import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";
import LastModificationAlert from "components/Common/Alert";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  FormFeedback,
  Input,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
} from "reactstrap";
import {
  FiUser,
  FiEdit3,
  FiChevronDown,
  FiChevronUp,
  FiEye,
} from "react-icons/fi";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import config from "config";
import FloatingFormActions from "components/Common/FloatingFormActions";
import IdentificationCard from "./IdentificationCard";
import AuditCard from "components/Common/SectionCard";
import DeleteButton from "components/Common/DeleteButtonShow";
import { useTranslation } from "react-i18next";
import TableComponent from "./TableComponent";
import HmfEdit from "./HmfEdit";

function BaseCalculDetail() {
  const { t } = useTranslation("");
  // **NOUVEL ÉTAT pour basculer entre show/edit**
  const backUrl = config.backOffice.url;
  const api = config.backOffice.apiName;
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isEditMode = urlParams.has("edit");
    setIsEditMode(isEditMode);
  }, []);
  // **TOUS LES ÉTATS EXISTANTS DU EditBases de calcul.js - IDENTIQUES**
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(true);
  const formEndRef = useRef(null);
  let currentLeftSideBar = localStorage.getItem("leftSideBar");
  const [leftPosition, setLeftPosition] = useState(
    localStorage.getItem("leftSideBar") === "icon" ? true : false
  );

  // Vérifier périodiquement (solution simple mais moins optimale)
  setInterval(() => {
    const newValue = localStorage.getItem("leftSideBar");
    if (newValue !== currentLeftSideBar) {
      currentLeftSideBar = newValue;
      const isIcon = newValue === "icon";
      setLeftPosition(isIcon);
    }
  }, 100); // Vérifier toutes les 100ms

  // Observer pour détecter si les boutons sont visibles
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowFloatingButtons(!entry.isIntersecting);
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -100px 0px", // Déclenche avant que l'élément disparaisse
      }
    );

    if (formEndRef.current) {
      observer.observe(formEndRef.current);
    }

    return () => observer.disconnect();
  }, [isEditMode, loading]);
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };
  const [isAccordionOpen1, setIsAccordionOpen1] = useState(true);
  const toggleAccordion1 = () => {
    setIsAccordionOpen1(!isAccordionOpen1);
  };
  const [wait, setWait] = useState(1000);

  let { id } = useParams();
  const navigate = useNavigate();
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  // **STYLES EXACTS du EditBases de calcul.js**
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            {t("Détails")}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  const tableaustyles = {
    background: "#3c88c8",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };

  const colStyle = {
    width: "15em",
    whiteSpace: "nowrap",
    display: "inline-block",
    paddingTop: "1px",
    color: "#7f7f7f",
    verticalAlign: "middle",
    display: "flex",
    alignItems: "center",
  };
  const layout = localStorage.getItem("layoutMode");
  const FIELD_DIMENSIONS = {
    height: "26px",
    minHeight: "26px",
    fontSize: "0.75rem",
    padding: "4px 6px",
    borderRadius: "4px",
    borderWidth: "1px",
  };
  const styleSelect = (isRequired) => ({
    control: (base, state) => ({
      ...base,
      height: FIELD_DIMENSIONS.height,
      minHeight: FIELD_DIMENSIONS.minHeight,
      borderRadius: FIELD_DIMENSIONS.borderRadius,
      // ✅ CONTOURS TRÈS SUBTILS
      border: isRequired
        ? "1px solid #dc3545"
        : state.isFocused
        ? "1px solid #80bdff" // ✅ Bleu très pâle
        : "1px solid white", // ✅ Gris ultra-subtil
      // ✅ PAS DE SHADOW ou shadow très légère
      boxShadow: state.isFocused
        ? isRequired
          ? "0 0 0 0.2rem rgba(220, 53, 69, 0.15)" // ✅ Shadow plus fine
          : "0 0 0 0.2rem rgba(0, 123, 255, 0.15)" // ✅ Shadow plus fine
        : "none",
      fontSize: FIELD_DIMENSIONS.fontSize,
      transition: "all 0.15s ease-in-out",
      backgroundColor: "#fff",
      "&:hover": {
        borderColor: isRequired
          ? "#dc3545"
          : state.isFocused
          ? "#80bdff"
          : "#c6cdd4", // ✅ Hover très doux
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: FIELD_DIMENSIONS.padding, // ✅ Même padding que les inputs
      height: `calc(${FIELD_DIMENSIONS.height} - 2px)`, // -2px pour les bordures
      display: "flex",
      alignItems: "center",
    }),
    input: (base) => ({
      ...base,
      margin: "0",
      padding: "0",
      fontSize: FIELD_DIMENSIONS.fontSize, // ✅ Cohérence taille police
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: FIELD_DIMENSIONS.fontSize,
      color: "#6c757d", // ✅ Même couleur placeholder que inputs
      opacity: 0.7,
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: FIELD_DIMENSIONS.fontSize,
      color: layout === "dark" ? "#fff" : "#212529", // ✅ Même couleur texte
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "6px", // ✅ Réduit pour cohérence
      color: "#6c757d",
      svg: {
        width: "13px", // ✅ Plus petit pour cohérence
        height: "13px",
      },
      "&:hover": {
        color: isRequired ? "#dc3545" : "#007bff",
      },
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
      color: "#6c757d",
      svg: {
        width: "10px",
        height: "10px",
      },
      "&:hover": {
        color: "#dc3545",
      },
    }),
    // ✅ Styles pour le menu déroulant (cohérence)

    menu: (base) => ({
      ...base,
      borderRadius: FIELD_DIMENSIONS.borderRadius,
      border: "1px solid #e9ecef",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      fontSize: FIELD_DIMENSIONS.fontSize,
      zIndex: "2147483647",
      marginTop: "-6px", // Au lieu de la valeur par défaut (8px)
      marginBottom: "0px",
    }),
    option: (base, state) => ({
      ...base,
      zIndex: 2147483647,
      fontSize: FIELD_DIMENSIONS.fontSize,
      padding: "6px 12px", // ✅ Padding cohérent
      backgroundColor: state.isSelected
        ? "#ebd826"
        : state.isFocused
        ? "#f8f9fa"
        : "white",
      color: state.isSelected ? "#212529" : layout === "dark" ? "#fff" : "#212529",
      "&:hover": {
        backgroundColor: state.isSelected
          ? isRequired
            ? "#dc3545"
            : "#007bff"
          : "#f8f9fa",
      },
    }),
  });
  const inputStyle = (isRequired) => ({
    height: FIELD_DIMENSIONS.height, // ✅ Hauteur fixe
    minHeight: FIELD_DIMENSIONS.minHeight, // ✅ Hauteur minimale
    borderRadius: FIELD_DIMENSIONS.borderRadius,
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    fontSize: FIELD_DIMENSIONS.fontSize,
    padding: FIELD_DIMENSIONS.padding, // ✅ Padding uniforme
    boxShadow: isRequired
      ? "0 1px 2px rgba(220,53,69,0.15)"
      : "0 1px 2px rgba(0,0,0,0.06)",
    border: isRequired ? "1px solid #dc3545" : "1px solid #e9ecef",
    lineHeight: "1.2", // ✅ Hauteur de ligne
    display: "flex", // ✅ Flexbox pour centrage
    alignItems: "center", // ✅ Centrage vertical
  });

  const token = localStorage.getItem("auth_token_" + api);
  const [OffreMetierData, setOffreMetier] = useState([]);
  const [Country, setCountry] = useState([]); // Ajout pour mode show
  const [activeTab, setActiveTab] = useState("details");
  // Map display labels to stable internal ids to avoid comparing locale text in logic
  const FIELD_LABEL_MAP = {
    [t("Défaut")]: "defaut",
    [t("Par défaut")]: "defaut",
    [t("UE")]: "ue",
    [t("Nom EN")]: "nom_en",
    [t("Nom EN")]: "nom_en",
    [t("Nom FR")]: "nom_fr",
    [t("Statut EN")]: "statut_en",
  };
  const getFieldId = (key) => FIELD_LABEL_MAP[key] || key;
  const [btnsecondary1, setBtnsecondary1] = useState(false);

  // **Définir les champs obligatoires - EXACT du EditBases de calcul.js**
  const requiredFields = ["Nom FR", "Défaut", "UE"];

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_base_de_calculs/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser");
        localStorage.removeItem("sideBar");
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const OffreMetierData = await response.json();
      setOffreMetier(OffreMetierData);
      setCodeComptable(
        OffreMetierData?.detail_record?.[t("Baremes")]?.data || []
      );
      // Charger les données de référence
      await Promise.all([getPeriode(), getFacturations()]);
    } catch (error) {
      console.error(error);
    }
  };

  // **Fonction getData POUR MODE SHOW**
  const getDataShow = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_base_de_calculs/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("sideBar");
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const CountryData = await response.json();
      setCountry(CountryData);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  // **TOUTES LES FONCTIONS EXISTANTES du EditBases de calcul.js - IDENTIQUES**
  const [facturation, setFacturation] = useState({ data: [] });
  const getFacturations = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/fx_base_de_calculs/fx_facturations`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setFacturation(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const renderFacturationOptions = () => {
    return [
      {
        options: facturation.result.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };

  const [periode, setPeriode] = useState({ data: [] });
  const getPeriode = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_base_de_calculs/periodes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setPeriode(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const renderPeriodeOptions = () => {
    return [
      {
        options:
          periode.result?.map((dataItem) => ({
            label: dataItem.label,
            value: dataItem.value,
          })) || [],
      },
    ];
  };

  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };

  const renderYesNoOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const renderOuiNonHmfOptions = () => {
    return [
      <option key="" value=""></option>,
      ...OuiNon?.data?.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {t("Non")}
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {t("Oui")}
      </div>
    );
  };
  // HMF
  const [codeComptable, setCodeComptable] = useState([]);
  //   console.log(codeComptable);
  const onAddCodeComptable = () => {
    const modifiedCodeComptable = [...codeComptable];
    // console.log(modifiedCodeComptable);
    modifiedCodeComptable.push({
      index: modifiedCodeComptable.length + 1,
      id: null,
      description: null,
      min: null,
      max: null,
      prix: null,
      actif: null,
    });

    setCodeComptable(modifiedCodeComptable);
  };
  const onDeleteCodeComptable = (id) => {
    setCodeComptable((prevState) =>
      prevState.map((item) =>
        item.index === id ? { ...item, _destroy: 1 } : item
      )
    );
  };

  const handleInputCodeComptableChange = (index, field, value) => {
    const modifiedCodeComptable = codeComptable.map((donnesCodeComptable) => {
      if (donnesCodeComptable.index === index) {
        return {
          ...donnesCodeComptable,
          [field]: value,
        };
      }
      return donnesCodeComptable;
    });

    setCodeComptable(modifiedCodeComptable);
  };
  // **FORMIK - EXACT du EditBases de calcul.js**
  const validationSchema = Yup.object({
    // Ajouter validation si nécessaire
  });

  const formik = useFormik({
    initialValues: {
      [t("Facturation")]:
        OffreMetierData.detail_record?.[t("Informations")]?.[
          t("Facturation")
        ] || "",
      [t("Base name")]:
        OffreMetierData.detail_record?.[t("Informations")]?.[t("Base name")] ||
        "",
      [t("Périodicité de calcul")]:
        OffreMetierData.detail_record?.[t("Informations")]?.[
          t("Périodicité de calcul")
        ] || "",
      [t("Nombre d'utilisateurs")]:
        OffreMetierData.detail_record?.[t("Informations")]?.[
          t("Nombre d'utilisateurs")
        ]?.value || "",
      [t("Max de la période")]:
        OffreMetierData.detail_record?.[t("Informations")]?.[
          t("Max de la période")
        ]?.value || "",
      [t("Fonction")]:
        OffreMetierData.detail_record?.[t("Informations")]?.[t("Fonction")] ||
        "",
      [t("Fonction V2")]:
        OffreMetierData.detail_record?.[t("Informations")]?.[
          t("Fonction V2")
        ] || null,
      [t("Forfaitaire (pack)")]:
        OffreMetierData.detail_record?.[t("Informations")]?.[
          t("Forfaitaire (pack)")
        ]?.value || "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_base_de_calculs/${id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              id: id,
              fx_facturation_id: values[t("Facturation")]?.value || "",
              base_name: values[t("Base name")],
              periode_value: values[t("Périodicité de calcul")]?.value || "",
              nb_users:
                values[t("Nombre d'utilisateurs")] ||
                values[t("Nombre d'utilisateurs")] == true
                  ? 1
                  : 2,
              max_period:
                values[t("Max de la période")] ||
                values[t("Max de la période")] == true
                  ? 1
                  : 2,
              fonction: values[t("Fonction")],
              fonction_v2: values[t("Fonction V2")],
              forfaitaire:
                values[t("Forfaitaire (pack)")] ||
                values[t("Forfaitaire (pack)")] == true
                  ? 1
                  : 2,
              baremes_attributes: codeComptable?.map((obj) => {
                const { index, ...rest } = obj;
                return rest;
              }),
            }),
          }
        );

        if (response.ok) {
          toast.success(t("Mis à jour avec succès!"));
          setIsEditMode(false);
          await getDataShow();
          await getData();
        } else {
          console.error("POST request failed");
          const responseData = await response.json();
          if (responseData?.message_validation) {
            responseData.message_validation.forEach((error) =>
              toast.error(error)
            );
          } else {
            toast.error("An error occurred");
          }
        }
      } catch (error) {
        console.error("Erreur:", error);
        toast.error(t("Erreur lors de la mise à jour"));
      }
    },
  });

  // **Fonction pour basculer les modes**
  const toggleEditMode = () => {
    if (!isEditMode) {
      setIsEditMode(true);
      // getData() // Charger données edit
    } else {
      setIsEditMode(false);
      getDataShow(); // Recharger données show
    }
  };
  const [mandatory_fields, setMandatory] = useState([]);
  const getMandatory = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/fx_base_de_calculs/mandatory_fields`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setMandatory(data?.mandatory_fields || []);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // Fonction pour vérifier si un champ est obligatoire
  const isRequiredField = (key) => mandatory_fields.includes(key);
  // **useEffect INITIAL**
  useEffect(() => {
    setLoading(true);
    // Charger en mode show par défaut
    getDataShow();
    getData();
    getMandatory();

    document.title = `${t("Bases de calcul")} | ${t("Détails")} | Fluxod}`;
  }, []);

  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);

  const handleGoBack = () => {
    window.history.back();
  };

  const handleDropDownActionsClick = (action) => {
    console.log("Action:", action);
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinners setLoading={setLoading} color="#3c88c8" />
      </div>
    );
  }
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  return (
    <>
      <div className="page-content">
        <Row>
          <Col xs="12">
            {!isEditMode ? (
              /* **MODE SHOW - Structure similaire à EditBases de calcul mais avec affichage** */
              <>
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/fx_base_de_calculs/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          {t("Bases de calcul")}{" "}
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          Country.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        {Country.can_edit ? (
                          <Link
                            onClick={toggleEditMode}
                            state={linkState}
                            className="btn btn-sm btn-primary"
                          >
                            <i className="bx bx-edit-alt"></i> {t("Modifier")}
                          </Link>
                        ) : null}
                        &nbsp; &nbsp;
                        {Country.can_destroy ? (
                          <DeleteButton
                            url={`https://www.fluxod.com/${api}/fx_base_de_calculs/${id}`}
                          />
                        ) : null}
                        {Country?.actions?.length > 0 ? (
                          <>
                            <>
                              &nbsp; &nbsp;
                              <Dropdown
                                isOpen={btnsecondary1}
                                toggle={() => setBtnsecondary1(!btnsecondary1)}
                              >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-sm btn-secondary"
                                >
                                  Actions <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  {Country?.actions.map((value, index) => (
                                    <>
                                      <DropdownItem
                                        onClick={() =>
                                          handleDropDownActionsClick(
                                            value.action
                                          )
                                        }
                                      >
                                        {value.label}
                                      </DropdownItem>
                                    </>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                {Country?.detail_record?.[t("Informations")] ? (
                                  <IdentificationCard
                                    title={t("Informations")}
                                    details={
                                      Country?.detail_record?.[
                                        t("Informations")
                                      ]
                                    }
                                    ids={Country?.detail_record?.ids}
                                    isAccordionOpen={isAccordionOpen}
                                    setIsAccordionOpen={setIsAccordionOpen}
                                  />
                                ) : null}
                              </Col>
                              <Col sm="6">
                                {Country?.detail_record?.[t("Baremes")] ? (
                                  <TableComponent
                                    title={t("Baremes")}
                                    header={
                                      Country?.detail_record?.[t("Baremes")]
                                        ?.header
                                    }
                                    data={
                                      Country?.detail_record?.[t("Baremes")]
                                        ?.data
                                    }
                                    setIsAccordionOpen={setIsAccordionOpen1}
                                    isAccordionOpen={isAccordionOpen1}
                                  />
                                ) : null}
                              </Col>
                              <Col sm="6">
                                {Country?.detail?.["Audit"] ? (
                                  <AuditInfo
                                    createdOn={
                                      Country?.detail?.["Audit"]?.["Created at"]
                                    }
                                    createdBy={
                                      Country?.detail?.["Audit"]?.["Created by"]
                                    }
                                    modifiedOn={
                                      Country?.detail?.["Audit"]?.["Updated at"]
                                    }
                                    modifiedBy={
                                      Country?.detail?.["Audit"]?.["Updated by"]
                                    }
                                  />
                                ) : null}
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}{" "}
                    <div ref={formEndRef} style={{ height: "1px" }} />
                    <div style={{ visibility: "hidden" }}>
                      <FloatingFormActions
                        showFloatingButtons={showFloatingButtons}
                        leftPosition={leftPosition}
                        onCancel={toggleEditMode}
                        onSubmit={formik.handleSubmit}
                        isSubmitting={formik.isSubmitting}
                        disabled={!formik.isValid}
                        submitText="Enregistrer les modifications"
                      />
                    </div>
                  </CardBody>
                </Card>
              </>
            ) : (
              /* **MODE EDIT - RENDU EXACT du EditBases de calcul.js** */
              <>
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/fx_base_de_calculs/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          {t("Bases de calcul")}
                        </Link>
                        <i className="bx bx-caret-right"></i>
                        {!loading ? (
                          OffreMetierData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>
                    <div
                      className="d-flex justify-content-end"
                      style={{ visibility: isEditMode ? "hidden" : "visible" }}
                    >
                      <div className="d-flex align-items-end">
                        {Country.can_edit ? (
                          <Link
                            onClick={toggleEditMode}
                            state={linkState}
                            className="btn btn-sm btn-info"
                            style={{ backgroundColor: "#004aff" }}
                          >
                            <i className="bx bx-edit-alt"></i> {t("Modifier")}
                          </Link>
                        ) : null}
                        &nbsp; &nbsp;
                        {Country.can_destroy ? (
                          <DeleteButton
                            url={`https://www.fluxod.com/${api}/fx_base_de_calculs/${id}`}
                          />
                        ) : null}
                        {Country?.actions?.length > 0 ? (
                          <>
                            <>
                              &nbsp; &nbsp;
                              <Dropdown
                                isOpen={btnsecondary1}
                                toggle={() => setBtnsecondary1(!btnsecondary1)}
                              >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-sm btn-secondary"
                                >
                                  Actions <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  {Country?.actions.map((value, index) => (
                                    <>
                                      <DropdownItem
                                        onClick={() =>
                                          handleDropDownActionsClick(
                                            value.action
                                          )
                                        }
                                      >
                                        {value.label}
                                      </DropdownItem>
                                    </>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                {OffreMetierData?.detail_record?.[
                                  t("Informations")
                                ] && (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        {/* <FiUser size={16} className="me-2" /> */}
                                        <span style={{ fontSize: "0.82rem" }}>
                                          {t("Informations")}
                                        </span>
                                      </div>
                                      {isAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    {/* Contenu repliable */}
                                    <Collapse isOpen={isAccordionOpen}>
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            OffreMetierData?.detail_record?.[
                                              t("Informations")
                                            ] || {}
                                          ).map(([key, value], index) => {
                                            const isRequired =
                                              isRequiredField(key);
                                            return (
                                              <div
                                                key={key}
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft: isRequired
                                                    ? "3px solid #dc3545"
                                                    : "3px solid transparent",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  if (isRequired) {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  if (isRequired) {
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }
                                                }}
                                              >
                                                {/* Ligne de séparation subtile */}
                                                {index > 0 && (
                                                  <div
                                                    className="field-separator"
                                                    style={{
                                                      position: "absolute",
                                                      top: "0",
                                                      left: "0",
                                                      right: "66%",
                                                      height: "1px",
                                                      background:
                                                        "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
                                                    }}
                                                  />
                                                )}

                                                <Row className="align-items-center g-1">
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    className="field-label"
                                                  >
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className={`fw-medium`}
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>

                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    className="field-input"
                                                  >
                                                    {key != t("Facturation") &&
                                                    key !=
                                                      t("Forfaitaire (pack)") &&
                                                    key !=
                                                      t("Max de la période") &&
                                                    key !=
                                                      t(
                                                        "Nombre d'utilisateurs"
                                                      ) &&
                                                    key !=
                                                      t(
                                                        "Périodicité de calcul"
                                                      ) ? (
                                                      <div className="input-wrapper position-relative">
                                                        <Input
                                                          className={`form-control-sm shadow-sm border-0 ${
                                                            formik.touched[
                                                              key
                                                            ] &&
                                                            formik.errors[key]
                                                              ? "is-invalid"
                                                              : ""
                                                          }`}
                                                          type={
                                                            key !=
                                                            t("Base name")
                                                              ? "textarea"
                                                              : "text"
                                                          }
                                                          rows="7"
                                                          name={key}
                                                          value={
                                                            formik.values[
                                                              key
                                                            ] ?? ""
                                                          }
                                                          onChange={
                                                            formik.handleChange
                                                          }
                                                          style={
                                                            key ==
                                                            t("Base name")
                                                              ? inputStyle(
                                                                  isRequired
                                                                )
                                                              : {}
                                                          }
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    ) : key ==
                                                        t(
                                                          "Forfaitaire (pack)"
                                                        ) ||
                                                      key ==
                                                        t(
                                                          "Max de la période"
                                                        ) ||
                                                      key ==
                                                        t(
                                                          "Nombre d'utilisateurs"
                                                        ) ? (
                                                      <div
                                                        className="switch-wrapper d-flex align-items-center"
                                                        style={{
                                                          height:
                                                            FIELD_DIMENSIONS.height,
                                                          minHeight:
                                                            FIELD_DIMENSIONS.minHeight,
                                                          padding: "0 0px",
                                                          backgroundColor:
                                                            "#fff",

                                                          borderRadius:
                                                            FIELD_DIMENSIONS.borderRadius,

                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                      >
                                                        <Switch
                                                          uncheckedIcon={
                                                            <Offsymbol />
                                                          }
                                                          checkedIcon={
                                                            <OnSymbol />
                                                          }
                                                          onColor={
                                                            localStorage.getItem(
                                                              "color_" + api
                                                            ) || "#555B21"
                                                          }
                                                          offColor="#6c757d"
                                                          onHandleColor="#fff"
                                                          offHandleColor="#fff"
                                                          handleDiameter={16}
                                                          borderRadius={10}
                                                          boxShadow="none"
                                                          activeBoxShadow="0 0 2px 4px rgba(0, 123, 255, 0.1)"
                                                          onChange={(option) =>
                                                            formik.setFieldValue(
                                                              key,
                                                              option
                                                            )
                                                          }
                                                          checked={
                                                            formik.values[
                                                              key
                                                            ] == 1
                                                              ? true
                                                              : false
                                                          }
                                                          className="uniform-switch"
                                                        />
                                                      </div>
                                                    ) : (
                                                      <div className="select-wrapper">
                                                        <Select
                                                          classNamePrefix="select2-selection"
                                                          styles={styleSelect(
                                                            isRequired
                                                          )}
                                                          options={
                                                            key ==
                                                            t("Facturation")
                                                              ? renderFacturationOptions()
                                                              : key ==
                                                                t(
                                                                  "Périodicité de calcul"
                                                                )
                                                              ? renderPeriodeOptions()
                                                              : []
                                                          }
                                                          name={key}
                                                          value={
                                                            formik.values[
                                                              key
                                                            ] || null
                                                          }
                                                          onChange={(option) =>
                                                            formik.setFieldValue(
                                                              key,
                                                              option
                                                            )
                                                          }
                                                          onBlur={
                                                            formik.handleBlur
                                                          }
                                                          isClearable={true}
                                                          placeholder={`Sélectionner ${key.toLowerCase()}...`}
                                                          menuPortalTarget={
                                                            document.body
                                                          }
                                                        />
                                                      </div>
                                                    )}

                                                    {formik.touched[key] &&
                                                      formik.errors[key] && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          {formik.errors[key]}
                                                        </div>
                                                      )}
                                                  </Col>
                                                </Row>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                )}
                              </Col>

                              <Col sm="6">
                                <HmfEdit
                                  title={t("Baremes")}
                                  hmfName={t("Baremes")}
                                  data={
                                    OffreMetierData?.detail_record?.[
                                      t("Baremes")
                                    ] || []
                                  }
                                  form={codeComptable}
                                  onAddForm={onAddCodeComptable}
                                  onDeleteForm={onDeleteCodeComptable}
                                  handleInputChange={
                                    handleInputCodeComptableChange
                                  }
                                  renderOuiNonOptions={renderOuiNonHmfOptions()}
                                  setIsAccordionOpen={setIsAccordionOpen1}
                                  isAccordionOpen={isAccordionOpen1}
                                />
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                        <div ref={formEndRef} style={{ height: "1px" }} />
                      </div>
                    )}

                    <FloatingFormActions
                      showFloatingButtons={showFloatingButtons}
                      leftPosition={leftPosition}
                      onCancel={toggleEditMode}
                      onSubmit={formik.handleSubmit}
                      isSubmitting={formik.isSubmitting}
                      disabled={!formik.isValid}
                      submitText={t("Enregistrer les modifications")}
                    />
                  </CardBody>
                </Card>
              </>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
}

export default BaseCalculDetail;
